<template>
  <section class="filters-wrapper">
    <!-- 筛选项面板 -->
    <div class="filters-panel" :style="`background-color: ${pageBackground};`" ref="filterPanelRef">
      <!-- 城市及二级筛选项 -->
      <div
        :class="`filters-row ${filterIsCeiling && !hasSubFilters ? 'filters-row--ceiling' : ''}`"
        ref="filtersRowRef"
        :style="`background-color: ${pageBackground}; padding-top: ${filterIsCeiling && !hasSubFilters ? 15 + statusBarH : 0}px;`"
      >
        <div class="filters-city" :class="filterPanelHasShadow ? 'filter-box-shadow' : ''" @click="changeCityListState()">
          <span class="text">{{curCity.cityName}}</span>
          <i class="triangle-down"></i>
        </div>
        <div class="filters-theme" :class="filterPanelHasShadow ? 'filter-box-shadow' : ''" @click="changeFiltersPanelState()">
          <span class="text">{{curFilter.labelName}}</span>
          <i :class="`${showFilterThemesPanel ? 'triangle-up' : 'triangle-down' }`"></i>
        </div>
        <!-- 二级筛选项选择面板 -->
        <div v-if="showFilterThemesPanel" class="filter-themes-panel" :style="`background: ${pageBackground}; top:${filterIsCeiling && statusBarH ? 55 + statusBarH : 55}px;`">
          <div class="themes">
            <div
              v-for="(filter, index) in themeFilters"
              :class="`filter-theme ${filter.labelKey === curFilter.labelKey ? 'filter-theme--selected' : ''}`"
              :style="calcFilterStyle(filter, index)"
              :key="index"
              @click="changeFilter($event, filter, index)"
            >{{filter.labelName}}</div>
          </div>
        </div>
      </div>
      <!-- 三级筛选项 -->
      <div
        v-show="subFilters.length > 0"
        :class="`subFilters-scroller-wrapper ${filterIsCeiling && hasSubFilters ? 'subFilters-scroller-wrapper--ceiling' : ''}`"
        ref="subFiltersWrapperRef"
        :style="`background-color: ${pageBackground}; padding-top: ${filterIsCeiling && hasSubFilters ? 15 + statusBarH : 15}px;`"
      >
        <cube-scroll ref="scrollRef" :data="subFilters" direction="horizontal" class="scroller-wrap">
          <ul class="subFilters-wrapper">
            <li v-for="(item, index) in subFilters" :key="index" class="subFilters-item" :style="calcSubFilterStyle(item)" @click="changeSubFilter($event, item, index)">{{ item.labelName }}</li>
          </ul>
        </cube-scroll>
      </div>
      <!-- 吸顶元素的占位元素 -->
      <div v-show="filterIsCeiling" class="filters-panel-placeHolder" ref="placeHolderRef" :style="{height: ceilingHeight}"></div>
    </div>
    <!-- 城市列表 -->
    <cube-popup type="city-list-popup" ref="popup" :zIndex="1009">
      <div class="popup-head">
        <div class="back-btn" @click="closeCityList()">
          <img :src="`${baseUrl}static/imgs/close-btn.png`">
        </div>
        <div class="title">城市选择</div>
      </div>
      <div v-if="renderCityList" class="city-list" ref="cityListRef">
        <cube-index-list :data="compProps.filters.cityList" @select="changeCity" style="height: 100%;"></cube-index-list>
      </div>
    </cube-popup>
    <!-- 房屋列表 -->
    <div class="filter-house-list" ref="filterHousesRef"  data-growing-container>
      <filter-house-list :compProps="compProps.houses" @action="actionHadler"></filter-house-list>
    </div>
  </section>
</template>
<script>
/* eslint-disable */
import FilterHouseList from '@/components/FilterHouseList'
import { Sniff } from '@/utils/q_sniff'
import { eventBus } from '@/utils'

// qunar App环境下，有原生头，不需要状态栏高度；没有原生头，需要处理状态栏高度
const getStatusBarH = (hastitle, platform) => {
  const height = 0
  if (
    Sniff &&
    Sniff.qunar &&
    (hastitle == 1 || platform === 6)
  ) {
    height = Sniff.statusBarH  
  }
  return height
}

export default {
  components: {
    FilterHouseList
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    filterPanelHasShadow: {
      type: Boolean,
      default: function() {
        return false
      }
    }
  },
  data() {
    return {
      showFilterThemesPanel: false,
      showCityList: false,
      filterIsCeiling: false,
      ceilingHeight: 0,
      renderCityList: false,
      statusBarH: 0
    }
  },
  computed: {
    curCity() {
      return this.compProps.filters.curCity || {}
    },
    curFilter() {
      return this.compProps.filters.curFilter || {}
    },
    curSubFilters() {
      return this.compProps.filters.curSubFilters || []
    },
    subFilters() {
      return this.compProps.filters.subFilters || []
    },
    hasSubFilters() {
      return this.subFilters.length > 0 ? true : false
    },
    themeFilters() {
      return this.compProps.filters.themeFilters || []
    },
    pageBackground() {
      return this.curFilter.pageBackground || '#fff'
    }
  },
  mounted() {
    const _self = this
    /* 筛选项吸顶 */
    const elem_html = document.documentElement
    const elem_body = document.body
    let isMounted = true

    const { hastitle } = this.$route.query
    const statusBarH = getStatusBarH(hastitle, this.platform)
    this.statusBarH = statusBarH
    // 监听图片组件的加载事件，在加载完成后，重新计算滚动的高度临界值
    eventBus.$on('imageOnload', function() {
      const hClientTop = elem_html.getBoundingClientRect().top 
      const bClientTop = elem_body.getBoundingClientRect().top
      const pClientTop = hClientTop !== 0 ?
        hClientTop :
        bClientTop !== 0 ?
          bClientTop : 0
      const housesClientTop = _self.$refs.filterHousesRef.getBoundingClientRect().top || 0
      const ceilingHeight = _self.hasSubFilters ? 142 : 75
      const filterPanel = _self.$refs.filterPanelRef.getBoundingClientRect().top || 0
      const scrollTop = filterPanel - pClientTop

      _self.filterScrollTop = scrollTop
      _self.subFiltersScrollTop = _self.hasSubFilters ? scrollTop + 55 : scrollTop
      _self.ceilingScrollTop = !_self.hasSubFilters ? _self.filterScrollTop : _self.subFiltersScrollTop
      !isMounted && _self.scrollToFilter(_self.hasSubFilters)
      isMounted = false
    })
    // 延时1s,等页面资源加载后再计算顶部距离
    setTimeout(() => {
      // 在组件实例上缓存渲染无关的属性
      this.filterScrollTop = this.$refs.filterPanelRef.getBoundingClientRect().top || 0
      this.subFiltersScrollTop = this.filterScrollTop + 55
      
      // 增加状态栏的高度
      if (Sniff && Sniff.qunar) {
        this.filterScrollTop += statusBarH
        this.subFiltersScrollTop += statusBarH
      }
      this.ceilingScrollTop = this.hasSubFilters ? this.subFiltersScrollTop : this.filterScrollTop
    }, 1000)
    document.onscroll = (e) => {
      /**
       * 目前发现不同浏览器版本下，页面的默认滚动元素可能是html，也可能是body，
       * 根据scrollTop值区分实际的滚动元素
       */
      const htmlScrollTop = parseFloat(elem_html.scrollTop)
      const bodyScrollTop = parseFloat(elem_body.scrollTop)
      const scrollTop = htmlScrollTop !== 0 ? htmlScrollTop : bodyScrollTop
      if (scrollTop >= this.ceilingScrollTop && _self.filterIsCeiling === false) {
        _self.filterIsCeiling = true
      } else if (scrollTop < this.ceilingScrollTop && _self.filterIsCeiling === true) {
        _self.filterIsCeiling = false
      }
    }
  },
  watch: {
    pageBackground(newVal, oldVal) {
      if (newVal !== oldVal) {
        document.body.style.backgroundColor = newVal
      }
    },
    // 三级筛选项的有无状态改变时，更新吸顶的滚动距离和占位元素高度，只改变值，不计算
    hasSubFilters(newVal, oldVal) {
      const elem_ceiling = this._getCeilingElem()
      setTimeout(() => {
        this.ceilingHeight = newVal ? '47px' : '40px'
      }, 0)
      // 在组件实例上缓存渲染无关的属性
      this.ceilingScrollTop = newVal ? this.subFiltersScrollTop : this.filterScrollTop
    }
  },
  methods: {
    changeFiltersPanelState() {
      if (this.showFilterThemesPanel) {
        this.closeFiltersPanel()
      } else {
        this.openFiltersPanel()
      }
    },
    openFiltersPanel() {
      this.showFilterThemesPanel = true
      this.$emit('action', { type: 'openFiltersPanel' })
    },
    closeFiltersPanel() {
      this.showFilterThemesPanel = false
      this.$emit('action', { type: 'closeFiltersPanel' })
    },
    changeCityListState() {
      if (this.showCityList) {
        this.closeCityList()
      } else {
        this.openCityList()
      }
    },
    openCityList() {
      this.showCityList = true
      this.$refs.popup.show()
      this.$emit('action', { type: 'openCityList' })
      // 弹层显示后，异步渲染城市列表的内容，保证列表的高度正确
      this.$nextTick(() => {
        this.renderCityList = true
      })
    },
    closeCityList() {
      this.showCityList = false
      this.$refs.popup.hide()
      this.renderCityList = false
      this.$emit('action', { type: 'closeCityList' })
    },
    // 改变选中城市
    changeCity(city, index) {
      this.changeCityListState()
      this.$refs.scrollRef.scrollTo(15, 0, 0)
      this.scrollToFilter()
      this.$emit('action', { type: 'changeCity', newCity: city })
    },
    // 改变选中的二级筛选项
    changeFilter($event, filter, index) {
      this.changeFiltersPanelState()
      this.$refs.scrollRef.scrollTo(15, 0, 0)
      if (filter.labelKey !== this.curFilter.labelKey) {
        filter.index = index
        this.scrollToFilter()
        this.$emit('action', { type: 'changeFilter', newFilter: filter })
      }
    },
    // 改变选中的三级筛选项
    changeSubFilter($event, subFilter, index) {
      // 三级筛选项支持复选和反选
      let selectedSubFilters = []
      let hasSelected = false
      selectedSubFilters = this.curSubFilters.filter((curSubFilter) => {
        if (curSubFilter.labelKey === subFilter.labelKey) {
          hasSelected = true
          return false
        } else {
          return true
        }
      })
      // 增加新选中的标签
      if (!hasSelected) {
        selectedSubFilters.push(subFilter)
      }
      this.scrollToFilter(true)
      this.$emit('action', { type: 'changeSubFilter', newSubFilters: selectedSubFilters, clickIndex: index })
    },
    // 页面顶部滚动到筛选项的位置,滚动到用户点击的筛选项层级
    scrollToFilter(isSubFilter = false) {
      const elem_html = document.documentElement
      const elem_body = document.body
      const ceilingScrollTop = isSubFilter ? this.subFiltersScrollTop : this.filterScrollTop
      if (elem_html.scrollTop !== 0) {
        elem_html.scrollTop = ceilingScrollTop
      }
      if (elem_body.scrollTop !==0) {
        elem_body.scrollTop = ceilingScrollTop
      }
    },
    // 计算二级筛选项的选中样式
    calcFilterStyle(filter, index) {
      const isSelected = filter.labelKey === this.curFilter.labelKey
      let style = isSelected ? 
        `border-color: ${this.curFilter.selectColor}; color: ${this.curFilter.selectColor};` :
        `border-color: ${this.curFilter.textColor}; color: ${this.curFilter.textColor};`
      style += (index + 1) % 4 === 0 ?
        'margin-right: 0;' :
        'margin-right: 15px;'
      return style
    },
    // 计算三级筛选项的选中style背景色
    calcSubFilterStyle(subFilter) {
      let isSelected = false
      this.curSubFilters.forEach((curSubFilter) => {
        if (curSubFilter.labelKey === subFilter.labelKey) {
          isSelected = true
        }
      })
      const style = isSelected ?
        `background-color: ${this.curFilter.selectColor}; color: #fff;`
        : ''
      return style
    },
    // 透传视图子组件的事件到UiComp组件
    actionHadler(payLoad) {
      this.$emit('action', payLoad)
    },
    // 获取筛选项的吸顶元素：有三级筛选项时，三级筛选项吸顶；只有二级筛选项，二级筛选项吸顶；
    _getCeilingElem() {
      return this.subFilters && this.subFilters.length > 0 ? this.$refs.subFiltersWrapperRef : this.$refs.filtersRowRef
    }
  } 
}
</script>
<style lang="scss">
.filters-wrapper {
  position: relative;
  // margin-left: 15px;
  // margin-right: 15px;
}
.filters-panel-placeHolder {
  height: 102px;
}
.filters-panel {
  position: relative;
  padding-left: 15px;
  padding-right: 15px;
}
.filters-panel--ceiling {
  position: fixed;
  z-index: 1001;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 20px;
}
.filters-row {
  display: flex;
}
.filters-row--ceiling {
  position: fixed;
  z-index: 1001;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 15px 15px 20px 15px;

  .filter-themes-panel {
    // margin-left: 14px;
    // margin-right: 14px;
    // width: calc(100% - 28px);
    // padding-left: 15px;
    // padding-right: 15px;
  }
}
.filter-box-shadow {
  box-shadow: 0 2px 18px 0 rgba(0, 0, 0, 0.1);
}

.filters-city,
.filters-theme {
  display: flex;
  align-items: center;
  border-radius: 4px;
  background: #fff;
  .text {
    margin-left: 14px;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
  }
  .triangle-down {
    margin-left: auto;
    margin-right: 10px;
    height: 0;
    width: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #666;
  }
  .triangle-up {
    margin-left: auto;
    margin-right: 10px;
    height: 0;
    width: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid #666;
  }
}
.filters-city {
  width: 8.67rem;
  height: 40px;
}
.filters-theme {
  flex: 1 1 auto;
  margin-left: 1rem;
  height: 40px;
}
.subFilters-scroller-wrapper {
  margin-left: -15px;
  padding-top: 1rem;
  width: calc(100% + 30px);
  .cube-scroll-content {
    display: inline-block;
  }
  .subFilters-wrapper {
    white-space: nowrap;
  }
  .subFilters-item {
    display: inline-block;
    margin-left: 15px;
    border-radius: 27px;
    box-sizing: border-box;
    min-width: 80px;
    padding-left: 1rem;
    padding-right: 1rem;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #fff;
    font-size: 12px;
    color: #666;
  }
  .subFilters-item:first-child {
    margin-left: 15px;
  }
  .subFilters-item:last-child {
    margin-right: 10px;
  }
  .subFilters-item--selected {
    background: #ffb000;
  }
}
.subFilters-scroller-wrapper--ceiling {
  position: fixed;
  z-index: 1001;
  top: 0;
  left: 0;
  box-sizing: border-box;
  margin-left: 0;
  width: 100%;
  // padding-left: 15px;
  // padding-right: 15px;
  padding-bottom: 20px;
}
/* 二级筛选项选择面板 */
.filter-themes-panel {
  position: absolute;
  top: 55px;
  left: 0;
  z-index: 999;
  padding-left: 15px;
  padding-right: 15px;
  width: calc(100% - 30px);

  .themes {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 20px 0 10px;
    min-height: 68px;
  }
  .filter-theme {
    box-sizing: border-box;
    margin-bottom: 10px;
    width: calc((100% - 45px) / 4);
    height: 25px;
    line-height: 23px;
    border: 1px solid #fff;
    border-radius: 4px;
    text-align: center;
    font-size: 12px;
    color: #fff;
  }
  .filter-theme--selected {
    border: 1px solid #ffc528;
  }
}
/* 城市列表弹层 */
.cube-city-list-popup {
  .cube-popup-container {
    .cube-popup-content {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
    }
    .popup-head {
      display: flex;
      align-items: center;
      height: 40px;
      line-height: 40px;
      background: #fff;

      .back-btn {
        position: absolute;
        left: 20px;
        width: 24px;
        height: 24px;
        line-height: 24px;
        font-size: 18px;
      }
      .back-btn img {
        margin-top: 5px;
        width: 14px;
        height: 14px;
      }
      .title {
        flex: 1 0 auto;
        display: flex;
        justify-content: center;
        font-size: 18px;
        color: #333;
      }
    }
    .city-list {
      height: calc(100% - 40px);
      background: #fff;
    }
  }
}
.filter-house-list {
  margin-right: 15px;
  margin-left: 15px;
}
.cube-index-list-nav > ul > li.active {
  color: #666;
}
</style>
